import * as React from 'react'
import styled from 'styled-components'

import NavigationPanel from 'components/NavigationPanel'
import Disclaimer from './Disclaimer'

const TourWrapper = styled.div`
  position: absolute;
  top: 0;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  transition: top 0.6s ease-in-out;

  @media (max-width: 575px) {
    top: ${p => (p.collapse ? '-100px' : '-350px')};
  }
`

export default function Krpano({ apartments, floors }) {
  const [krpano, setKrpano] = React.useState(null)
  const [hLookAt, setHLookAt] = React.useState(0)
  const [collapse, setCollapse] = React.useState(false)
  // Prevent duplicate krpanoSWFObject div elements
  const krpanoRef = React.useRef(null)

  React.useEffect(() => {
    const initKrpano = () => {
      if (
        typeof window !== 'undefined' &&
        krpano === null &&
        krpanoRef.current === null
      ) {
        window.embedpano({
          swf: 'vtour/tour.swf', // path to flash viewer (use null if no flash fallback will be required)
          id: 'krpanoSWFObject',
          xml: 'vtour/tour.xml',
          target: 'tour',
          bgcolor: '#FFFFFF',
          consolelog: false, // trace krpano messages also to the browser console
          passQueryParameters: true, // pass query parameters of the url to krpano
          onready: krpano_interface => {
            setKrpano(krpano_interface)
            krpanoRef.current = krpano_interface
          },
        })
      }
    }

    initKrpano()
  }, [krpano, krpanoRef])

  React.useEffect(() => {
    const getHLookAt = () => {
      window.getHLookAt = krpano => {
        if (krpano) {
          setHLookAt(krpano.get('view.hlookat'))
        }
      }
    }
    getHLookAt()
  })

  return (
    <>
      <TourWrapper
        id="tour"
        collapse={Boolean(collapse) ? 'true' : undefined}
      />
      <NavigationPanel
        krpano={krpano}
        hLookAt={hLookAt + 200}
        apartments={apartments}
        floorsData={floors}
        collapse={collapse}
        setCollapse={setCollapse}
      />
      <Disclaimer />
    </>
  )
}
